export const GrayoutCamera = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 3C2.46957 3 1.96086 3.21071 1.58579 3.58579C1.21071 3.96086 1 4.46957 1 5V11C1 11.5304 1.21071 12.0391 1.58579 12.4142C1.96086 12.7893 2.46957 13 3 13H8.5C9.03043 13 9.53914 12.7893 9.91421 12.4142C10.2893 12.0391 10.5 11.5304 10.5 11V5C10.5 4.46957 10.2893 3.96086 9.91421 3.58579C9.53914 3.21071 9.03043 3 8.5 3H3ZM13.2933 12.5L11.5 10.7067V5.29333L13.2933 3.5C13.9227 2.87 15 3.316 15 4.20667V11.7933C15 12.684 13.9227 13.13 13.2933 12.5Z"
      fill="#FFFFFF8C"
    />
  </svg>
);
